import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatViews } from "@/utils/movie";

export default function MovieListItem({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex cursor-pointer gap-4 rounded-lg border border-background-200/80 bg-background-100/60 p-3 transition-colors hover:border-primary-300"
      title={`${movie.title} - 熊猫影院`}
    >
      <div className="h-36 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-3">
          <h3 className="truncate text-base font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
            {movie.title}
          </h3>
          <span className="flex shrink-0 items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
            <i className="ri-star-fill text-[10px]"></i>
            {movie.rating.toFixed(1)}
          </span>
        </div>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">
            {movie.typeLabel}
          </span>
          <span>{movie.year}</span>
          <span>{movie.region}</span>
          <span>{movie.duration}</span>
        </div>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-2 pt-3">
          {movie.genres.map((g) => (
            <span
              key={g}
              className="rounded-full border border-background-300/70 px-2.5 py-0.5 text-xs text-foreground-600"
            >
              {g}
            </span>
          ))}
          <span className="ml-auto flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-play-circle-line text-[13px]"></i>
            {formatViews(movie.views)}次播放
          </span>
        </div>
      </div>
    </Link>
  );
}